<template >
  <a-card :bordered="false">
    <a-tabs v-model="activeKey" type="editable-card" @edit="onEdit">
        <a-tab-pane  :tab="$t('dashboard.analysis.site')" key="1" :closable="false">
            <analysismode  @onActic="onActiced"></analysismode>
        </a-tab-pane>
        <a-tab-pane v-if="onActicedFrame"  :tab="$t('dashboard.analysis.acticedFrame')" key="2" :closable="false">
          <a-alert type="info" showIcon style="margin-bottom: 16px;">
            <template slot="message">
                  <div style="width:100%;display:flex;justify-content:space-around;align-items:center;flex-wrap:wrap;">
                    <div v-for="(value, index) in analyPrament" v-bind:key="index">
                    <span style="color:#666;"> {{ value.name }}</span>：<span style="color: #1890ff;">{{value.value}}</span>
                   </div>
                  </div>
            </template>
          </a-alert>
          <div v-bind:style="{display:isShowAnalysisBody ? 'flex' : 'block', justifyContent:'space-around', gap:'20px'}">
            <AnalysisCopy style="flex:1" ref="siscopy" @onActicWarehouse="onActicedWarehouse" :acticeData="AnalysismodeData" />
            <AnalysisBody style="flex:1" ref="sisboby" @onActicWarehouse="onActicedSelf" :acticeData="isAnalysisiBodyData" v-if="isShowAnalysisBody"/>
            <AnalysisSelf style="flex:1" ref="sisself" :acticeData="isAnalysisiSelfData" v-if="isShowAnalysisSelf"></AnalysisSelf>
          </div>
        </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import Analysismode from './Analysismode.vue'
import AnalysisCopy from './AnalysisCopy.vue'
import AnalysisBody from './AnalysisBody.vue'
import AnalysisSelf from './AnalysisSelf.vue'

export default {
  components: {
    Analysismode,
    AnalysisBody,
    AnalysisCopy,
    AnalysisSelf
  },
  data () {
      return {

        activeKey:"1",
        onActicedFrame:false,
        isShowAnalysisBody:false,
        isShowAnalysisSelf:false,
        AnalysismodeData:{},
        isAnalysisiSelfData:{},
        analyPrament:[]
      }
  },
  async mounted(){

  },
  methods: {
    initTileAlert(event){
      // 组合数据
      this.analyPrament = [{
        name: this.$t("dashboard.analysis.address"),
        value:event.address
      },{
        name: this.$t("dashboard.analysis.city"),
          value:event.city
      },{
          name:this.$t("dashboard.analysis.contactPhone"),
          value:event.contactPhone
      },{
        name:this.$t("dashboard.analysis.countryCode"),
        value:event.countryCode
      },{
        name:this.$t("dashboard.order.siteName"),
          value:event.name
      },{
        name:this.$t("dashboard.analysis.postalCode"),
          value:event.postalCode
      },{
        name:this.$t("dashboard.analysis.serviceRadius"),
        value:event.serviceRadius
      },{
        name:this.$t("dashboard.analysis.stateProvince"),
          value:event.stateProvince
      }]
    },
    onEdit(event){
      console.log(event)
    },
    onActiced(event){
      if(this.onActicedFrame){
        this.$refs.siscopy.searchReset({
          siteId:event.id
        })
      }

      this.initTileAlert(event)

      this.activeKey = "2"
      this.onActicedFrame = true
      this.AnalysismodeData = event
      console.log(this.activeKey, event)

      this.isShowAnalysisSelf = false
      this.isShowAnalysisBody = false
      this.isAnalysisiBodyData = {}
      this.isAnalysisiSelfData = {}
    },
    onActicedSelf(event){
      if(this.isShowAnalysisSelf){
        this.$refs.sisself.searchReset({
          aisleId:event.id
        })
      }

      this.isShowAnalysisSelf = true
      this.isAnalysisiSelfData = event
      console.log(this.activeKey, event)
    },
    onActicedWarehouse(event){
      if(this.isShowAnalysisBody){
        this.$refs.sisboby.searchReset({
          warehouseId:event.id
        })
      }

      this.isShowAnalysisBody = true
      this.isAnalysisiBodyData = event
      this.isShowAnalysisSelf = false
    }
  }
}
</script>
<style lang="">

</style>
